<template>
  <div class="graph">
    <v-card>
      <v-card-text v-if="loading" class="text-xs-center pt-3">
        <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
      </v-card-text>

      <v-container v-else fluid grid-list-md>
        <v-layout row wrap>
          <!-- Colonne gauche : saisie -->
          <v-flex xs12 sm4>
            <v-card class="pa-3">
              <v-select
                v-model="suggestionsProxy"
                :items="questions"
                item-text="valeur"
                item-value="cle"
                label="Analyses"
                multiple
                chips
                return-object
                hint="paramétrez votre analyse"
                persistent-hint
              />
              <v-textarea
                v-model="analyseMessage"
                label="Votre demande personalisée"
                clearable
                auto-grow
                outlined
              ></v-textarea>

              <v-btn
                :loading="loadingData"
                :disabled="loadingData"
                color="primary"
                block
                class="mt-2"
                @click="sendMAnalyseChat"
              >
                Analyser
              </v-btn>
            </v-card>
          </v-flex>

          <!-- Colonne droite : réponse -->
          <v-flex xs12 sm8>
            <v-card class="pa-3" height="100%">
              <v-card-text>
                <div v-html="cleanedAnalyseResponse" class="markdown-output text-xs-left"></div>
                <!-- Le graphique Highcharts -->
                <div v-for="(config, i) in parseMultipleHighchartsConfigs(analyseResponse)" :key="i">
                  <highcharts :options="config"></highcharts>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <div class="text-xs-left">
        <v-btn flat @click="openChats()" color="accent" v-if="histoready">
          {{ $t('hideChat') }}
          <v-icon  right>visibility_off</v-icon>
        </v-btn>
        <v-btn flat @click="openChats()" color="accent" v-else>
          {{ $t('showChat') }}
          <v-icon right>visibility</v-icon>
        </v-btn>
      </div>
    </v-card>

    <!-- Historique des chats -->
    <wz-histo-chats
      :params="params"
      :numChatsTotal="String(chatsOK)"
      v-if="histoready"
    ></wz-histo-chats>

  </div>
</template>

<script>
import _ from 'lodash'
import json2csv from 'json2csv'
import moment from 'moment'
import MarkdownIt from 'markdown-it'
import 'moment-duration-format'
import { mapGetters, mapState } from 'vuex'

export default {
  data () {
    return {
      md: new MarkdownIt(),
      suggestions: {},       // ton objet clé: valeur
      questions: [
        {
          cle: `q1`,
          valeur: `nombre de messages par jour`,
          description: `
            affiche dans un graphique le nombre de messages recus par jours.
          `
        },
        {
          cle: `q2`,
          valeur: `top 10 des sources`,
          description: `
            Affiche dans un graphique le top 10 des sources utiliser pour les réponse de l'IA.
          `
        },
        {
          cle: `q3`,
          valeur: `Produits Proposés`,
          description: `
            affiche dans un graphique le nombre de produits poussé dans un conversation par jours.
          `
        },
        {
          cle: `q4`,
          valeur: `conversations par jour`,
          description: `
            Affiche dans un graphique le nombre de conversations par jour.
            Une conversation entre un visiteur unique (ref idvisiteur) et un agent.
          `
        }
      ],
      analyseMessage: '',
      analyseResponse: '',
      chartOptions: null,   // config highcharts
      loading: false,
      loadingData: false,
      loadingExportData: false,
      chatsOK: 0,
      nbMessages: 0,
      panel: [true, false],
      visiteurs: [],
      histoready: false,
      filterChats: {
        type: Boolean,
        default: false
      },
      optionsJauge: {
        chart: {
          type: 'solidgauge',
          height: 180
        },
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        pane: {
          size: '220',
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '95%'],
          background: {
            backgroundColor: '#ddd',
            outerRadius: '100%',
            innerRadius: '90%',
            shape: 'arc',
            borderColor: 'transparent'
          }
        },
        tooltip: {
          enabled: false
        },
        yAxis: {
          min: 0,
          lineWidth: 0,
          minorTickInterval: null,
          tickAmount: 2,
          title: {
            text: ''
          }
        },
        plotOptions: {
          solidgauge: {
            innerRadius: '90%',
            dataLabels: {
              y: 5,
              borderWidth: 0,
              useHTML: true
            }
          }
        },
        series: [{
          data: [0]
        }]
      },
      // options pour chacun des graphiques jauges
      chatsMissed: {
        title: {
          text: _.upperFirst(this.$tc('chatsMissed', 2, {count: ''}))
        },
        yAxis: {
          stops: [[0, '#009688']], // teal
          max: 100
        },
        series: [{
          dataLabels: {
            format: `<div style="text-align:center;font-size:32px;color:` + this.$vuetify.theme.primary + `;">{y:.1f} %</span></div>`
          }
        }]
      }
    }
  },

  created () {
    // initialisation des options liées aux graphiques
    this.chatsMissed = _.merge(this.chatsMissed, this.optionsJauge)
    this.getAll()
  },

  methods: {
    /**
     * lance toutes les requêtes
     */
    getAll () {
      // affichage des loader
      this.loading = true
      Promise.all([
        this.getChatsAnalyse()

      ])
    },
    getChatsMissed () {
      return new Promise((resolve, reject) => {
        this.axios.get('get/chats_missed.php?' + this.params)
        .then(response => {
          this.chatsOK = response.data.chatsOK
          this.chatsKO = response.data.chatsKO
          // calcul du ratio de chats manqués
          this.totalChats = this.chatsKO + this.chatsOK
          let ratio = (this.chatsKO / this.totalChats) * 100
          // mise à jour du graphique avec les données récupérées et calculées
          this.chatsMissed.series[0].data[0] = ratio
          this.chatsMissed.yAxis.title.text = this.chatsKO + ' chats'
          resolve()
        })
        .catch((e) => { reject(e) })
      })
    },
    download () {
      this.loadingExportData = true
      let csv = null
      const fields = [
        'chats',
        'messages'
      ]
      const fieldNames = [
        this.$tc('chats', 2, { count: '' }),
        this.$tc('messages', 2, { count: '' })
      ]
      const data = {
        chats: this.chatsOK,
        messages: this.nbMessages
      }
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        this.loadingExportData = false
        return
      }

      // téléchargement du fichier csv
      var hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = 'chats.csv'
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
      this.loadingExportData = false
    },
    onSelectChange (values) {
      // transformer le tableau en objet clé: valeur
      this.suggestions = values.reduce((acc, item) => {
        acc[item.cle] = item.valeur
        return acc
      }, {})
    },
    openChats (indexPage) {
      console.log('openChats', this.params)
      if (this.histoready) {
        this.histoready = false
      } else {
        this.histoready = true
      }
    },
    getChatsAnalyse () {
      console.log('getChatsAnalyse', this.params)
      this.loadingHisto = true
      this.loading = true
      this.axios
        .get('get/chats_analyse.php?' + this.params)
        .then(response => {
          // vide le tableau des visiteurs
          this.visiteurs = _.isArray(response.data) ? response.data : []
          // this.allCarousels = _.cloneDeep(this.visiteurs)
          _.each(this.visiteurs, visiteur => {
            visiteur.duration = moment
              .duration(visiteur.duration, 'seconds')
              .format('h [h] m [m] s [s]')
            visiteur.averageResponse = moment
              .duration(visiteur.averageResponse, 'seconds')
              .format('h [h] m [m] s [s]')
            // chaque conversation
            _.each(visiteur.chats, conversation => {
              _.each(conversation.messages, message => {
                message.text = message.text.replaceAll('&lt;', '<')
                message.text = message.text.replaceAll('&gt;', '>')
                if (message.text === 'undefined') message.text = null
                message.unix = message.date
                if (message.agentName === 'undefined') {
                  let userFound = this.$store.getters['_User/getUserById'](
                    message.agentId
                  )
                  message.agentName = userFound
                    ? userFound.USR_FIRST_NAME + ' ' + userFound.USR_LAST_NAME
                    : ''
                }
                let date = moment.unix(message.unix)
                message.date = date.format('LTS')
                conversation.last = _.clone(message)
                conversation.last.date = date.calendar()
              })
            })
          })

          // Affichage par défaut du premier chat
          // du premier visiteur
          if (this.chatsSorted[0]) {
            this.showChat(this.chatsSorted[0].chats[0].id)
          }
        })
        .catch(errors => {
          this.loading = false
          this.loadingHisto = false
        })
        .then(_ => {
          this.loading = false
          this.loadingHisto = false
          this.listChats = true
        })
    },

    /* eslint-disable no-useless-escape */
    /**
     * Envoie un message à l'IA pour qu'elle l'analyse et
     * affiche la réponse de l'IA.
     */
    async sendMAnalyseChat () {
      console.log('send analyse')
      this.loadingData = true
      let urlAI = 'https://lb-sw-ai-prod.watcheebox.net/analyseSemantique'
      // si c'est en dev c'est pas la même url
      if (process.env.NODE_ENV === 'development') {
        // c'est du dev donc pas la même url
        urlAI = 'https://lb-sw-ai-dev-v2.watcheebox.net/analyseSemantique'
      } else if (process.env.NODE_ENV === 'preprod') {
        // c'est du dev donc pas la même url
        urlAI = 'https://lb-sw-ai-preprod-v2.watcheebox.net/analyseSemantique'
      }

      let conversationTexte = this.visiteurs.map(visiteur => {
        return `\n=== Conversations du visiteur ${visiteur.visId || 'inconnu'} ===` +
          visiteur.chats.map(chat => {
            let conversation = `\nConversation id:${chat.id}`
            let bloc = '' // bloc regroupant tous les messages du chat

            chat.messages.forEach(msg => {
              // conversion du timestamp en date complète
              const dateObj = new Date(parseInt(msg.unix, 10) * 1000)
              const dateComplete = dateObj.toLocaleString(`fr-FR`, {
                day: `2-digit`,
                month: `2-digit`,
                year: `numeric`,
                hour: `2-digit`,
                minute: `2-digit`,
                second: `2-digit`
              })

              // texte de base
              if (msg.auteur === 'Visiteur') {
                bloc += `'${dateComplete} - ${msg.auteur} id:${visiteur.visId}, message: ${msg.text}`
              } else if (msg.auteur === 'Agent') {
                bloc += `'${dateComplete} - ${msg.auteur} id:${msg.agentId}, message: ${msg.text}`
              }

              // si c'est un message du visiteur → indiquer à quel agent (id) il a été envoyé
              if (msg.auteur === `Visiteur` && msg.agentId) {
                bloc += `  (to agent Id:${msg.agentId})`
              }

              // si l’agent a fourni une liste d’URL
              if (msg.params && msg.params.listeMostRelevantUrl && msg.params.listeMostRelevantUrl.length > 0) {
                bloc += `\n   🔗 products:`
                msg.params.listeMostRelevantUrl.forEach((item, i) => {
                  bloc += `\n     product:${i + 1}, url:${item.url}, score:${item.similarityScore}`
                })
              }

              // si l’agent a utilisé une source pour sa réponse
              if (msg.params && msg.params.source) {
                bloc += `\n   🔗 Source:${msg.params.source}`
              }

              bloc += `\n' \n` // fermeture du message
            })

            return conversation + ': {\n' + bloc + '\n}'
          }).join('\n')
      }).join('\n')

      // ${this.analyseMessage}
      // Analyse les conversations suivantes entre un internaute et un agent.
      let promptDescription = `
        
        Pour analyse les conversations, fournis les éléments suivants :

        ${this.prompt}

        ${this.analyseMessage}
        Liste des conversations :
        ${conversationTexte}
        Si on te demande la création de graphiques,
        tu dois fournire uniquement un tableau avec les series avec les données demandés compatible pour "highcharts".
        ainsi que le type de graphique, le titre, le xAxis et le yAxis de celui-ci.
        IMPORTANT :
        - ecris un JSON valide utilisant strictement les caractéristiques de l'exemple ci-dessous en respectant les regles suivantes.
        - Toutes les clés doivent être entre des double quotes.
        - series doit être entre des double quotes.
        - Toutes les valeurs string doivent être entre des double quotes.
        - Pas de "..." ou de texte hors JSON.
        - Pas de double quotes échappés \" à l'intérieur d'une clé ou d'une valeur.
        - Tu peux retourner plusieur JSON si il y une demande de plusieurs graphiques.
        exemple de json :
        "chart": {
          "type": "solidgauge",
          "height": 180
        },
        "yAxis": {
          "stops": [[0, "#E91E63"]],
          "max": 120
        },
        "xAxis": {
          "categories": []
        },
        "title": {
          "text": "titre"
        },
        "series": [{
            "name": "URLs",
            "data": [
                {"name": "name1", "y": "val1"},
                {"name": "name2", "y": "val2"}
            ]
        }]
      `

      let dataMessage = {
        network: 'openAI',
        message: { type: 'text', content: this.analyseMessage },
        attachments: '',
        WZAgentId: this.$store.state._User.id,
        messageType: 1,
        auteur: 'Agent',
        siteId: this.$store.state._User.licenceId,
        entrepriseId: this.$store.state._User.entId,
        entrepriseKey: this.$store.state._User.entKey,
        licenceKey: this.$store.state._User.licAllKeys[0],
        chatSession: '',
        senderId: this.$store.state._User.id,
        jsonAPI: {},
        btob: 0,
        newFront: 1
      }

      let dataToPost = {
        promptDescription: promptDescription,
        searchResponse: '10',
        tokenResponse: '10000',
        model: 'gpt-4o-mini',
        modelTokens: '128000',
        temperature: '0.1',
        dialogExemple: '',
        histoMessages: [],
        functionCalls: [],
        analyseChat: [],
        parsingSelectif: [],
        parseElement: '',
        methodSelect: '',
        jsonAPI: {},
        botStream: false,
        contextAI: '',
        dataMessage: dataMessage,
        syntheseVocale: 0,
        listeUrls: [],
        productSelectAuto: false,
        language: 'FR'
      }
      if (!this.analyseMessage.trim() && !this.prompt.length) return

      this.analyseResponse = '⏳ Réponse en cours...'

      // ✅ Retourne directement la Promise
      try {
        const response = await this.axios.post(
          urlAI,
          dataToPost
        )
        console.log('analyse bot response', response.data.data.data.response)
        this.analyseResponse = this.md.render(response.data.data.data.response || 'Pas de réponse')

        // const config = this.parseHighchartsConfigFromResponse(response.data.data.data.response)
        // if (config) {
        //   this.chartOptions = config
        // }
        this.loadingData = false
        return {
          retour: 1,
          data: response.data
        }
      } catch (err) {
        console.log('analyse bot err', err)
        this.analyseResponse = this.md.render('❌ Erreur : ' + err.message)
        this.loadingData = false
        return {
          retour: 0,
          data: err
        }
      }
    },

    // fonction principale : retourne un tableau d'objets JS (configs)
    parseMultipleHighchartsConfigs (response) {
      if (!response || typeof response !== 'string') return []

      // utilitaires locaux
      const decode = (s) => {
        // très simple, utilise DOMParser si dispo (navigateur)
        try {
          const doc = new DOMParser().parseFromString(s, 'text/html')
          return (doc && doc.body && doc.body.textContent) ? doc.body.textContent : s
        } catch (e) {
          return s.replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
        }
      }

      const normalizeWhitespace = (s) =>
        s.replace(/^\uFEFF/, '') // BOM
        .replace(/[\u00A0\u200B-\u200D\u202F]/g, ' ') // espaces insécables, zero-width...
        .trim()

      // nettoyage "agressif" pour essayer de rendre JSON.parse possible
      const aggressiveClean = (txt) => {
        let t = txt

        t = decode(t)
        t = normalizeWhitespace(t)

        // remplacements simples
        t = t.replace(/[\u2018\u2019\u201C\u201D]/g, '"') // quotes typographiques -> "
        t = t.replace(/\\?&quot;|&quot;/g, '"') // &quot; -> "
        t = t.replace(/\\?&apos;|&#39;/g, "'") // numeric entities -> '
        t = t.replace(/\\?&amp;/g, '&')

        // enlever commentaires JS, multi-lignes
        t = t.replace(/\/\/.*$/gm, '')
        t = t.replace(/\/\*[\s\S]*?\*\//g, '')

        // virer ellipses
        t = t.replace(/\.\.\./g, ' ')

        // remplacer placeholders <count> par 0
        t = t.replace(/<count>/g, '0')

        // remplacer undefined
        t = t.replace(/\bundefined\b/g, 'null')

        // remplacer simples quotes autour de valeurs :   : 'val'  ->  : "val"
        t = t.replace(/:\s*'([^']*?)'/g, ': "$1"')

        // mettre entre quotes les clés non-quotées (heuristique)
        t = t.replace(/([{\[,]\s*)([A-Za-z0-9_\-@\$]+)\s*:/g, '$1"$2":')

        // cas fréquent : objects with a trailing numeric value: {"name":"xx", 4} -> {"name":"xx","y":4}
        t = t.replace(/(\{\s*"(?:name|label|title)"\s*:\s*"[^"]*"\s*),\s*([0-9]+)\s*(\})/g, '$1"y":$2$3')

        // remplacer des paires name":"... ", 4  -> name:"...", "y":4
        t = t.replace(/("name"\s*:\s*"[^"]*")\s*,\s*([0-9]+)(\s*[},])/g, '$1, "y": $2$3')

        // virer virgules traînantes avant ] ou }
        t = t.replace(/,(\s*[}\]])/g, '$1')

        // s'assurer que "y": n'est pas en quotes (si l'IA a fait "y":"4")
        t = t.replace(/"y"\s*:\s*"(\d+)"?/g, '"y": $1')

        // petite normalisation : convertir simples quotes restantes en doubles s'il s'agit de valeurs simples
        t = t.replace(/'([^']*?)'/g, '"$1"')

        // trim final
        return t.trim()
      }

      // 1) normaliser réponse
      let text = response || ''
      text = decode(text)
      text = normalizeWhitespace(text)

      const configs = []

      // 2) d'abord extraire blocs ```json ... ``` ou ```
      const codeBlockRegex = /```(?:json)?\s*([\s\S]*?)\s*```/gi
      let m
      const blocks = []
      while ((m = codeBlockRegex.exec(text)) !== null) {
        if (m[1]) blocks.push(m[1].trim())
      }

      // 3) si pas de blocs, on tombera sur extraction top-level {...}
      if (blocks.length === 0) {
        // extraire par scanning top-level (respecte strings & échappements)
        const objs = []
        const len = text.length
        let i = 0
        while (i < len) {
          const start = text.indexOf('{', i)
          if (start === -1) break
          let depth = 0
          let inString = false
          let escape = false
          let j = start
          for (; j < len; j++) {
            const ch = text[j]
            if (escape) { escape = false; continue }
            if (ch === '\\') { escape = true; continue }
            if (ch === '"') { inString = !inString; continue }
            if (!inString) {
              if (ch === '{') depth++
              else if (ch === '}') {
                depth--
                if (depth === 0) {
                  objs.push(text.slice(start, j + 1).trim())
                  i = j + 1
                  break
                }
              }
            }
          }
          if (j >= len) break
        }
        blocks.push(...objs)
      }

      // 4) tenter de parser chaque bloc : d'abord brut, sinon après aggressiveClean
      for (const raw of blocks) {
        // try direct parse
        try {
          const parsed = JSON.parse(raw)
          configs.push(parsed)
          continue
        } catch (err1) {
          // essayer nettoyage agressif
          try {
            const cleaned = aggressiveClean(raw)
            const parsed2 = JSON.parse(cleaned)
            configs.push(parsed2)
            continue
          } catch (err2) {
            // dernier recours : tenter nettoyage encore plus permissif (log + skip)
            console.warn('Impossible de parser ce bloc même après nettoyage (skip). Erreur:', err2.message)
            console.warn('Bloc (truncated):', raw.slice(0, 500))
          }
        }
      }
      console.log('configs', configs)
      return configs
    }
  },
  /* eslint-enable no-useless-escape */

  computed: {
    ...mapGetters('_Stats', ['params']),
    ...mapState('_User', ['entLevel']),
    suggestionsProxy: {
      get () {
        // Transformer l'objet {clé: valeur} en tableau [{cle, valeur}, ...]
        return Object.entries(this.suggestions).map(([cle, valeur]) => {
          return { cle, valeur }
        })
      },
      set (values) {
        // Transformer le tableau [{cle, valeur}, ...] en objet {clé: valeur}
        this.suggestions = values.reduce((acc, item) => {
          acc[item.cle] = item.valeur
          return acc
        }, {})
      }
    },
    prompt () {
      // Les clés sélectionnées
      const cles = Object.keys(this.suggestions)

      // Construire un texte enrichi avec description
      const details = cles.map(cle => {
        const q = this.questions.find(q => q.cle === cle)
        return `- ${q.valeur} → ${q.description}`
      }).join('\n')

      return `${details}`
    },
    // Texte à afficher sans la config Highcharts
    cleanedAnalyseResponse () {
      if (!this.analyseResponse) return ''
      // Chercher un bloc JSON : entre premier { et dernier }
      const start = this.analyseResponse.indexOf('{')
      const end = this.analyseResponse.lastIndexOf('}')
      if (start !== -1 && end !== -1 && end > start) {
        // Retirer le JSON du texte
        const jsonPart = this.analyseResponse.slice(start, end + 1)
        return this.analyseResponse.replace(jsonPart, '').trim()
      }
      return this.analyseResponse // pas de JSON détecté
    }
  },

  watch: {
    params (v) {
      this.getAll()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stats/graph.vue